import { SeesawIcon } from './SeesawIcon';

/**
 * author: Michael Irigoyen
 * id B2FB9E28-A275-4BC8-AFD9-8A8D90153ED9
 * name seesaw
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seesaw.svg
 * tags
 */
export const PlaygroundSeesawIcon = SeesawIcon;
export default PlaygroundSeesawIcon